import React from "react";
import PropTypes from "prop-types";
import { Button } from "@cars24/turbo-web/lib/button";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";

const PostDiySellerPackageCard = ({ cardData, onClick }) => {
    const { tokens } = useTokens();
    const { title, image, meta, subTitle, ctaText } = cardData || {};

    return (
        <div styleName={"styles.postDiySellerPackageCardWrapper"}>
            <div styleName={"styles.cardBackground"}>
                <img src={meta?.backgroundUrl} alt={title}/>
            </div>
            <div styleName={"styles.postDiySellerPackageCardText"}>
                <Text size="300" fontWeight="semibold" color={tokens.text_default_text_primary}>
                    {title}
                </Text>
                <div styleName={"styles.subTextWrapper"}>
                    <img src={image?.url} alt={image?.alternativeText} width="56px" height="56px" />
                    <div styleName={"styles.textSubText"}>
                        <Text as="span" size="200" fontWeight="semibold" color="#8E8161">
                            {meta?.highlightSubTitle}
                        </Text>
                        <Text as="p" size="200" fontWeight="regular" color={tokens.text_default_text_primary}>
                            {subTitle}
                        </Text>
                    </div>
                </div>
                <Button
                    label={ctaText}
                    onClick={onClick}
                    size="medium"
                    variant="secondary"
                />
            </div>
        </div>
    );
};

PostDiySellerPackageCard.propTypes = {
    cardData: PropTypes.object,
    onClick: PropTypes.func
};

export default PostDiySellerPackageCard;
